import { Link } from "react-router-dom";
import { Bot, Sparkles } from "lucide-react";

const QUICK = [
  { title: "2 Days in Jaipur", tag: "Budget trip" },
  { title: "Family Trip", tag: "Udaipur & Mount Abu" },
  { title: "Spiritual Journey", tag: "Temples & Ashrams" },
];

export default function AIPlanner() {
  return (
    <section id="ai" className="bg-white pb-20">
      <div className="container-page">
        <div className="flex flex-col items-center gap-6 rounded-2xl bg-gradient-to-r from-iris-50 to-lavender p-6 sm:p-8 lg:flex-row">
          <div className="grid h-20 w-20 shrink-0 place-items-center rounded-2xl bg-white text-iris-500 shadow-sm">
            <Bot size={40} strokeWidth={1.5} />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h3 className="font-display text-xl font-bold text-navy-900">
              Let our AI plan your perfect journey
            </h3>
            <p className="mt-1 text-sm text-slate-600">
              Tell us your budget, interests, duration and we&apos;ll create a
              personalized itinerary just for you.
            </p>
            <Link to="/signup" className="btn-primary mt-4">
              <Sparkles size={16} /> Plan My Journey →
            </Link>
          </div>
          <div className="grid w-full gap-2 sm:grid-cols-3 lg:w-auto">
            {QUICK.map((q) => (
              <div
                key={q.title}
                className="rounded-xl border border-white bg-white/70 px-4 py-3 text-center shadow-sm"
              >
                <div className="text-sm font-semibold text-navy-900">{q.title}</div>
                <div className="text-xs text-slate-500">{q.tag}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
